import { Group, Text, Tooltip, type TextProps } from "@mantine/core";

type MinutesPlayedProps = {
  minutes: number | null | undefined;
  substitute?: boolean | null | undefined;
  showIcon?: boolean;
} & TextProps;

export function MinutesPlayed({
  minutes,
  substitute,
  showIcon = false,
  ...textProps
}: MinutesPlayedProps) {
  return (
    <Group gap="xs" wrap="nowrap">
      <Group gap="xs" align="center" wrap="nowrap">
        <Text>{showIcon ? "⏱️" : null}</Text>
        <Text {...textProps} style={{ fontFamily: "monospace" }}>
          {minutes ? `${minutes}'` : "DNP"}
        </Text>
      </Group>
      {minutes && substitute ? (
        <Tooltip label="Substitute">
          <Text style={{ cursor: "default" }}>⬆️</Text>
        </Tooltip>
      ) : null}
    </Group>
  );
}
